module.exports = __webpack_public_path__ + "img/2023_Nature.21c68549.png";